import { IconButton, Typography } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

import { PolicyTable } from '../../types/cancelAndModifyPolicies'
import useStyles from './styles/PoliciesFormAvailablePoliciesRow.styles'

interface PoliciesFormAvailablePoliciesRowProps {
  policiesData: PolicyTable
  onDelete: (data: PolicyTable) => void
}
const PoliciesFormAvailablePoliciesRow: React.FC<
  PoliciesFormAvailablePoliciesRowProps
> = ({ policiesData, onDelete }) => {
  const {
    deadline,
    deadlineTimeOffset,
    penaltyAmount,
    penaltyType,
    priority,
    policyType
  } = policiesData
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">{priority}</Typography>
      </div>
      <div>
        <Typography variant="body1">{penaltyAmount}</Typography>
      </div>
      <div>
        <Typography variant="body1">{penaltyType}</Typography>
      </div>
      <div>
        <Typography variant="body1">
          {deadline > 1000 ? 'no deadline' : deadline}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{deadlineTimeOffset}</Typography>
      </div>
      <div>
        <Typography variant="body1">{policyType}</Typography>
      </div>
      <div>
        <IconButton onClick={() => onDelete(policiesData)}>
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default PoliciesFormAvailablePoliciesRow
